module.exports = __webpack_public_path__ + "img/6.59e9268f.jpg";